import { MuiRootProps } from "types/mui"
import { Midnight, Tetons } from "./colours"

/**
 * - Styles override to MUIChip to match Vacasa owner onboarding design
 */
const muiChip = {
    styleOverrides: {
        root: ({ ownerState, theme }: MuiRootProps) => ({
            borderRadius: "40px",
            textTransform: "none",
            height: "32px",
            lineHeight: "16px",
            backgroundColor: Midnight[10],
            color: "inherit",
            ...(ownerState.size === "small" && {
                ...theme.typography.headingTinyCaps,
            }),
            ...(ownerState.size === "medium" && {
                ...theme.typography.headingXSmallCaps,
            }),
            "&.Mui-disabled": {
                backgroundColor: Tetons[30],
                color: Tetons[100],
            },
        }),
    },
}

export default muiChip
